import React, { Component, Fragment } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Editor } from '@tinymce/tinymce-react';
import { withLocalize } from 'react-localize-redux';
import { get, isEmpty } from 'lodash';
import axios from 'axios';

import FileUploader from '../../uploader/Modal';
import { emptyDiv } from '../../forms/constants/eventContent';


import { handleResponseCode } from '../../actions/index';
import { HHAlert, hlog } from '../../common/util';
import { ALERT_TYPE } from '../../common/constant';
import { PUBLIC_BUCKET_CDN, POST_UPLOAD_ACTION } from '../../network/api';

class EdittableContent extends Component {
  state = { isEditting: false, editor: null };

  toggleEditting = () => {
    this.setState({ isEditting: !this.state.isEditting }, () => {
      // focus textarea after click
      if (this.state.isEditting) {
        this.state.editor.focus();
      }
    });
  };

  postUpload = async (parameter) => {
    try {
      const res = await axios.post(POST_UPLOAD_ACTION, parameter);
      const { code, response } = res.data;
      if (response && code === 200) {
        return response;
      }
      handleResponseCode(code);
      return {};
    } catch (err) {
      HHAlert({ id: 'alert.error.uploadFailed' }, ALERT_TYPE.ERROR);
      hlog(err);
      return {};
    }
  };


    handleChange = async key => {
      const { editor } = this.state;
      const { userToken, slug, fileType } = this.props;
      const parameter = {
        token: userToken,
        files: [
          {
            objectKey: key,
            fileType,
            objectPathTemplateData: {
              eventSlug: slug
            }
          }
        ],
        eventSlug: slug
      };

      const res = await this.postUpload(parameter);
      if (isEmpty(res)) return;
      const newObjectKey = get(res, ['keysToAttributes', `${key}`, 'newObjectKey']);
      if (newObjectKey) {
        setTimeout(() => {
          editor.insertContent(`<img style='width: 100%; max-width:100%;' src=${`${PUBLIC_BUCKET_CDN}${newObjectKey}`}  referrerPolicy="no-referrer" />`);
        }, [1000]);
      }
    };

    render() {
      const { isEditting } = this.state;
      const {
        value, onChange, translate, maxImageSizeMB, ...otherProps
      } = this.props;

      const language =
      localStorage.getItem('language') && localStorage.getItem('language').slice(0, 2) === 'zh' ? 'zh_CN' : 'en';

      const init = {
        language,
        plugins: 'link image imagetools preview fullscreen lists table textcolor paste',
        paste_auto_cleanup_on_paste: true,
        menubar: false,
        statusbar: false,
        toolbar1: 'undo redo | cut copy paste | preview link addImageBtn | fontselect fontsizeselect forecolor backcolor',
        // eslint-disable-next-line
      toolbar2: 'bold italic underline strikethrough superscript subscript | alignleft aligncenter alignright | bullist numlist table',
        entity_encoding: 'raw',
        default_link_target: '_blank',
        inline_styles: false,
        setup: editor => {
          this.setState({ editor });
          editor.addButton('addImageBtn', {
            icon: 'image',
            onclick: () => {
              this.fileUploader.handleOpen();
              editor.focus();
            }
          });
        }
      };

      const isEmpty = emptyDiv === value;

      return (
        <Fragment>
          <FileUploader
            onRef={fu => { this.fileUploader = fu; }}
            accept='image/*'
            cropRatios={['free', '16:9', '1:1']}
            onChange={this.handleChange}
            {...otherProps}
            maxImageSizeMB={maxImageSizeMB}
            trigger={<div />}
          />
          <div hidden={!isEditting} className='eventDetail_main_detail_content-edit'>
            <Editor
              init={init}
              value={value}
              onEditorChange={onChange}
              onBlur={this.toggleEditting}
              inline
            />
          </div>
          <div
            onClick={this.toggleEditting}
            hidden={isEditting}
            className={`eventDetail_main_detail_content${isEmpty ? '-default' : ''}`}
          >
            {isEmpty ? translate('eventDetailContent') : ReactHtmlParser(value)}
          </div>
        </Fragment>
      );
    }
}

export default withLocalize(EdittableContent);



// WEBPACK FOOTER //
// ./src/components/contentEditor/components/edittableContent.js